module.exports = __webpack_public_path__ + "static/media/flora_projects.68886a2f.jpg";